import { jsx as _jsx } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { MenuLinkBase } from '#pplx/frontend/aether/components/internal/menu/MenuLinkBase.js';
import { useMenuClose } from '#pplx/frontend/aether/components/internal/menu/useMenuContext.js';
import { DropdownMenuPrimitive } from '#pplx/frontend/aether/primitives/DropdownMenuPrimitive/index.js';
import { useCallback } from 'react';
export function MenuLinkItem({ children, disabled, href, onClick, ...rest }) {
    const { isMobileStyle } = useAetherContext();
    const closeMobileMenu = useMenuClose();
    const handleMobileClick = useCallback((event) => {
        if (disabled) {
            return;
        }
        onClick?.(event);
        closeMobileMenu?.();
    }, [closeMobileMenu, disabled, onClick]);
    // Mobile renders within a dialog (i.e: bottom sheet) so
    // we don't need to wrap within an accessible menu item.
    if (isMobileStyle) {
        return (_jsx(MenuLinkBase, { href: href, "aria-disabled": disabled, role: "link", onClick: handleMobileClick, ...rest, children: children }));
    }
    return (_jsx(DropdownMenuPrimitive.Item, { disabled: disabled, children: _jsx(MenuLinkBase, { href: href, onClick: onClick, ...rest, children: children }) }));
}
//# sourceMappingURL=MenuLink.js.map